/**
 * Dialog for the FAQ page, you can set the linkType of the GsFaqItemGroup to DIALOG_LINK. This will make it open in a modal
 *
 * @author Erik Slagter
 */
import $ from 'jquery';
import Dialog from 'components/dialogs/dialog';
import DialogTypes from 'components/dialogs/Types';
export default {
  $faq: null,
  initialize(selector) {
    const defaultSelector = '.js-faqSection';
    this.$faq = $(selector || defaultSelector);

    this.bindEvents();
  },

  bindEvents() {
    this.$faq.on('vclick', '.js-dialogLink', this.showFaqDialog.bind(this));
  },

  showFaqDialog(e) {
    e.preventDefault();

    const $a = $(e.currentTarget);
    const href = $a.attr('href');

    Dialog.show({
      className: 'dialog--default dialog--faq',
      cssDependencies: ['/_ui/g-star/css/page--faq.css'],
      filterResponseSelector: '.js-faq-titleMain, .js-faqSection, .js-faq-dialogButtonsContainer',
      id: 'faq-dialog',
      jsDependencies: () => {
        return import(/* webpackChunkName: "dialog--faq" */ 'components/faq/FaqAccordion');
      },
      type: DialogTypes.FREQUENTLY_ASKED_QUESTIONS,
      url: href
    }).then(function(dialogInstance, jsModules) {
      // Initialize the FAQ module
      jsModules[0].initialize(dialogInstance.$dialog.find('.js-faqSection'));
    });
  }
};
